<template>
  <div class="login">
    <van-nav-bar title="会员登录" left-arrow @click-left="$router.go(-1)" />
    <div class="container">
      <div class="title">
        <h3>账号密码登录</h3>
        <p>使用注册的账号和密码登录</p>
      </div>
      <div class="form">
        <div class="form-item">
          <input class="inp" type="text" v-model.trim="account" maxlength="20" placeholder="请输入账号">
        </div>
        <div class="form-item">
          <input class="inp" type="password" v-model="password" maxlength="20" placeholder="请输入密码" @keyup.enter="Login">
        </div>
      </div>
      <div class="login-btn" :class="{ disabled: loading }" @click="Login">登 录</div>
      <div class="links">
        <span class="link" @click="$router.push('/register')">没有账号？立即注册</span>
      </div>

      <!-- 微信内置浏览器内显示：微信一键登录 -->
      <div class="wechat-login" v-if="isWechat">
        <div class="divider"><span>其他登录方式</span></div>
        <div class="wechat-btn" :class="{ disabled: loading }" @click="wechatLogin">
          <i class="wechat-icon"></i>
          <span>微信一键登录</span>
        </div>
      </div>
      
    </div>
  </div>
</template>

<script>
import { LoginApi, getWechatLoginUrlApi } from '@/api/login'
import { Toast } from 'vant'

export default {
  name: 'Login',
  data () {
    return {
      account: '',
      password: '',
      loading: false,
      // 是否在微信内置浏览器中打开（仅在微信内展示微信登录入口）
      isWechat: /micromessenger/i.test(navigator.userAgent)
    }
  },
  methods: {
    async Login () {
      if (!this.account) {
        Toast('请输入账号')
        return
      }
      if (!this.password) {
        Toast('请输入密码')
        return
      }
      if (this.loading) return
      this.loading = true
      try {
        const { data } = await LoginApi(this.account, this.password)
        // 将用户信息保存到 vuex 中（含 token）
        this.$store.commit('user/setUserInfo', data)
        this.loginSuccess()
      } catch (err) {
        const msg = typeof err === 'string' ? err : (err && err.message) || '登录失败，请稍后重试'
        Toast(msg)
      } finally {
        this.loading = false
      }
    },
    // 登录成功后的统一处理
    loginSuccess () {
      Toast('登录成功')
      setTimeout(() => {
        // 支持从受保护页面跳转登录（?redirect=xxx）后回跳
        const redirect = this.$route.query.redirect
        if (redirect) {
          this.$router.replace(redirect)
          return
        }
        // 有历史记录则返回上一页，否则回首页
        if (window.history.length > 1) {
          this.$router.go(-1)
        } else {
          this.$router.replace('/home')
        }
      }, 800)
    },
    // 微信一键登录：获取微信授权地址并跳转
    async wechatLogin () {
      if (this.loading) return
      this.loading = true
      try {
        // 传入当前页面需要的回跳地址（如从受保护页跳转来登录）
        const redirect = this.$route.query.redirect || ''
        const { data } = await getWechatLoginUrlApi(redirect)
        if (!data || !data.url) {
          throw new Error('获取微信授权地址失败')
        }
        // 授权完成后微信会回跳到 /wechatauth?code=xxx&state=xxx
        window.location.href = data.url
      } catch (err) {
        Toast(typeof err === 'string' ? err : '获取微信授权地址失败，请稍后重试')
      } finally {
        this.loading = false
      }
    }
  }
}
</script>

<style lang="less" scoped>
.container {
  padding: 60px 29px;

  .title {
    margin-bottom: 30px;

    h3 {
      font-size: 26px;
      font-weight: 400;
    }

    p {
      line-height: 40px;
      font-size: 14px;
      color: #b8b8b8;
    }
  }

  .form-item {
    border-bottom: 1px solid #f3f1f2;
    padding: 8px;
    margin-bottom: 14px;
    display: flex;
    align-items: center;

    .inp {
      display: block;
      border: none;
      outline: none;
      height: 32px;
      font-size: 14px;
      flex: 1;
    }

    img {
      width: 94px;
      height: 31px;
    }

    button {
      height: 31px;
      border: none;
      font-size: 13px;
      color: #cea26a;
      background-color: transparent;
      padding-right: 9px;
    }
  }

  .login-btn {
    width: 100%;
    height: 42px;
    margin-top: 39px;
    background: linear-gradient(90deg, #ecb53c, #ff9211);
    color: #fff;
    border-radius: 39px;
    box-shadow: 0 10px 20px 0 rgba(0, 0, 0, 0.1);
    letter-spacing: 2px;
    display: flex;
    justify-content: center;
    align-items: center;

    &.disabled {
      opacity: 0.6;
    }
  }

  .links {
    margin-top: 24px;
    text-align: center;

    .link {
      font-size: 14px;
      color: #ff6b35;
    }
  }

  .demo-tip {
    margin-top: 40px;
    text-align: center;
    font-size: 12px;
    color: #b8b8b8;
  }

  .wechat-login {
    margin-top: 44px;

    .divider {
      display: flex;
      align-items: center;
      font-size: 12px;
      color: #b8b8b8;

      &::before,
      &::after {
        content: '';
        flex: 1;
        height: 1px;
        background: #f3f1f2;
      }

      span {
        padding: 0 12px;
      }
    }

    .wechat-btn {
      margin-top: 24px;
      height: 42px;
      border: 1px solid #07c160;
      border-radius: 39px;
      color: #07c160;
      font-size: 15px;
      letter-spacing: 1px;
      display: flex;
      justify-content: center;
      align-items: center;

      &.disabled {
        opacity: 0.6;
      }

      .wechat-icon {
        width: 22px;
        height: 22px;
        border-radius: 50%;
        margin-right: 8px;
        background: #07c160;
        position: relative;

        // 微信气泡图标（两个圆形气泡）
        &::before,
        &::after {
          content: '';
          position: absolute;
          border-radius: 50%;
          background: #fff;
        }

        &::before {
          width: 8px;
          height: 8px;
          left: 4px;
          top: 5px;
        }

        &::after {
          width: 8px;
          height: 8px;
          right: 4px;
          bottom: 4px;
        }
      }
    }
  }
}
</style>